import AgentLoanOfficer from './AgentLoanOfficer';

export default AgentLoanOfficer;
